/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicBudgetSettings extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicBudgetSettings");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicBudgetSettings.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicBudgetSettings>): BackgroundJobPayloadForPeriodicBudgetSettings {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicBudgetSettings(), model);
        BackgroundJobPayloadForPeriodicBudgetSettings.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicBudgetSettings>): BackgroundJobPayloadForPeriodicBudgetSettings {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicBudgetSettings.newInstance(<BackgroundJobPayloadForPeriodicBudgetSettings> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicBudgetSettings) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicBudgetSettings.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicBudgetSettings): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicBudgetSettings.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
